// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__39eYf","notes":"Notes_notes__a9WzF"};